export default {"src":"/_next/static/media/link-mark.bbbcacd1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};